import { render } from "./UnlinkList.vue?vue&type=template&id=5628298e"
import script from "./UnlinkList.vue?vue&type=script&lang=js"
export * from "./UnlinkList.vue?vue&type=script&lang=js"
script.render = render

export default script